(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .controller("LearningItemTranslationsImportFileModalCtrl", ["$scope", "notify", "_", "Upload", "$timeout", learningItemTranslationsImportFileModalCtrl]);
    function learningItemTranslationsImportFileModalCtrl($scope, notify, _, Upload, $timeout) {
        var vm = this;
        vm.messages = [];
        vm.importComplete = false;
        vm.fileNameError = false;
        vm.fileUploadProgressValue = 0;
        vm.fileUploadErrors = [];
        vm.downloadFailedItemsCsvFile = downloadFailedItemsCsvFile;
        vm.closeAndRefresh = closeAndRefresh;
        function downloadFailedItemsCsvFile() {
            var date = new Date();
            var dateString = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate() + " " + date.getHours() + "-" + date.getMinutes() + "-" + date.getSeconds();
            var blob = new Blob([vm.csvImportProcessViewModel.failedLearningItemLocalizationString]);
            window.saveAs(blob, "LearningItemTranslations." + dateString + "." + vm.csvImportProcessViewModel.fileLanguageCultureName + ".csv");
        }
        ;
        function closeAndRefresh() {
            $scope.$close();
        }
        ;
        vm.validateFileNamePattern = function (file) {
            if (file) {
                var csvFormat = /(.*?)\.(.*?)\.(.*?)\.(csv)/;
                if (!csvFormat.test(file.name)) {
                    return "namePattern";
                }
                return true;
            }
            return false;
        };
        vm.upload = function (file) {
            if (file) {
                file.upload = Upload.upload({
                    url: "api/learningItemLocalizations/importCsv",
                    data: {
                        file: file
                    }
                });
                file.upload.then(function (response) {
                    $timeout(function () {
                        vm.csvImportProcessViewModel = response.data;
                        $scope.$apply(function () {
                            if (vm.csvImportProcessViewModel.errorMessageViewModels.length > 0) {
                                if (vm.csvImportProcessViewModel.errorMessageViewModels[0].message === "translations.learningItem.import.languageNotFoundErrorMessage") {
                                    vm.fileNameError = true;
                                }
                                else {
                                    vm.fileNameError = false;
                                }
                            }
                            else {
                                vm.fileNameError = true;
                            }
                            vm.importComplete = true;
                        });
                        vm.progress = 0;
                    });
                }, function (response) {
                    if (response.status > 0) {
                        var error = response.data.exceptionMessage
                            ? response.data.exceptionMessage
                            : response.data.message;
                        notify({
                            "messageTemplate": "<span data-translate>" + error + "</span>",
                            "classes": "alert-danger"
                        });
                    }
                    vm.progress = 0;
                }, function (evt) {
                    vm.progress = Math.min(100, Math.round(100.0 * evt.loaded / evt.total));
                });
            }
        };
    }
})();
